import axios from 'axios'

export const listpage = params => { return axios.post(`/admin/device/category/query`, params) }
export const save = params => { return axios.post(`/admin/device/category`, params) }
export const all = params => { return axios.get(`/admin/device/category/list`, { params: params }) }
export const remove = params => { return axios.delete(`/admin/device/category/${params.id}`, { params: params }) }
export const get = params => { return axios.get(`/admin/device/category/` + params.id, { params: params }) }



// WEBPACK FOOTER //
// ./src/services/api/admin/category/index.js